function asArray(value) {
    return Array.isArray(value) ? value : [];
}

function cloneHeader(header) {
    return {
        startDate: header && header.startDate ? header.startDate : "",
        endDate: header && header.endDate ? header.endDate : "",
    };
}

function getRowHeight(row) {
    var height = Number(row && row.measuredHeight);
    return isNaN(height) || height < 0 ? 0 : height;
}

function getHeaderHeight(section) {
    var height = Number(section && section.headerHeight);
    return isNaN(height) || height < 0 ? 0 : height;
}

function getSectionGap(input) {
    var gap = Number(input && input.sectionGap);
    return isNaN(gap) || gap < 0 ? 0 : gap;
}

function getPageInset(input) {
    var inset = Number(input && input.pageInset);
    return isNaN(inset) || inset < 0 ? 0 : inset;
}

function getRowLayout(section) {
    return section && section.rowLayout === "horizontal" ? "horizontal" : "vertical";
}

function getRowsHeight(section, rows) {
    var currentRows = asArray(rows);

    if (getRowLayout(section) === "horizontal") {
        return currentRows.reduce(function(maxHeight, row) {
            var rowHeight = getRowHeight(row);
            return rowHeight > maxHeight ? rowHeight : maxHeight;
        }, 0);
    }

    return currentRows.reduce(function(total, row) {
        return total + getRowHeight(row);
    }, 0);
}

function pushPage(pages, sections) {
    if (!sections.length) {
        return;
    }

    pages.push({
        pageIndex: pages.length,
        sections: sections,
    });
}

function createSplitSections(section, maxPageHeight) {
    var rows = asArray(section && section.rows);
    var headerHeight = getHeaderHeight(section);
    var pages = [];
    var currentRows = [];
    var rowIndex;
    var row;
    var nextHeight;

    for (rowIndex = 0; rowIndex < rows.length; rowIndex += 1) {
        row = rows[rowIndex];
        nextHeight = headerHeight + getRowsHeight(section, currentRows.concat([row]));

        if (currentRows.length > 0 && nextHeight > maxPageHeight) {
            pages.push({
                sectionKey: section.sectionKey,
                sectionHeader: cloneHeader(section.sectionHeader),
                continued: pages.length > 0,
                rowLayout: getRowLayout(section),
                rows: currentRows,
            });
            currentRows = [];
            nextHeight = headerHeight + getRowsHeight(section, [row]);
        }

        currentRows.push(row);
    }

    if (currentRows.length) {
        pages.push({
            sectionKey: section.sectionKey,
            sectionHeader: cloneHeader(section.sectionHeader),
            continued: pages.length > 0,
            rowLayout: getRowLayout(section),
            rows: currentRows,
        });
    }

    return pages;
}

function getSectionHeight(section) {
    return getHeaderHeight(section) + getRowsHeight(section, section && section.rows);
}

function paginateMeasuredSections(input) {
    var maxPageHeight = Number(input && input.maxPageHeight);
    var sections = asArray(input && input.sections).filter(function(section) {
        return asArray(section && section.rows).length > 0;
    });
    var availableHeight = maxPageHeight - getPageInset(input);
    var sectionGap = getSectionGap(input);
    var pages = [];
    var currentPageSections = [];
    var currentPageHeight = 0;
    var index;
    var section;
    var sectionHeight;
    var requiredHeight;

    if (isNaN(maxPageHeight) || availableHeight <= 0) {
        return [];
    }

    for (index = 0; index < sections.length; index += 1) {
        section = sections[index];
        sectionHeight = getSectionHeight(section);
        requiredHeight = currentPageSections.length > 0 ? currentPageHeight + sectionGap + sectionHeight : sectionHeight;

        if (sectionHeight <= availableHeight) {
            if (currentPageSections.length > 0 && requiredHeight > availableHeight) {
                pushPage(pages, currentPageSections);
                currentPageSections = [];
                currentPageHeight = 0;
                requiredHeight = sectionHeight;
            }

            currentPageSections.push({
                sectionKey: section.sectionKey,
                sectionHeader: cloneHeader(section.sectionHeader),
                continued: false,
                rowLayout: getRowLayout(section),
                rows: asArray(section.rows),
            });
            currentPageHeight = requiredHeight;
            continue;
        }

        if (currentPageSections.length > 0) {
            pushPage(pages, currentPageSections);
            currentPageSections = [];
            currentPageHeight = 0;
        }

        createSplitSections(section, availableHeight).forEach(function(splitSection) {
            pushPage(pages, [splitSection]);
        });
    }

    pushPage(pages, currentPageSections);
    return pages;
}

module.exports = {
    paginateMeasuredSections: paginateMeasuredSections,
    createSplitSections: createSplitSections,
    getSectionHeight: getSectionHeight,
    asArray: asArray,
};
